module.exports = __webpack_public_path__ + "static/media/23.95d0a0d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/23.jpg
// module id = 713
// module chunks = 0